export enum DWRResponseType {
	Success = 'Success',
	BadCombination = 'BadCombination',
	TooManyAttempts = 'TooManyAttempts',
	ParseError = 'ParseError',
}
